module.exports = "/_next/static/images/0100a685afcb3e1a0fd441bf7cca996b-people-smile-at-home-md@2x.jpg.webp";